"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDocumentWithDependencies = void 0;
var structured_analysis_type_codes_1 = require("../constants/structured-analysis-type-codes");
var DocumentsAndDependencies = [
    {
        document: structured_analysis_type_codes_1.QUALITY_OF_EARNINGS,
        dependencies: [structured_analysis_type_codes_1.REPORTED_INCOME_STATEMENT],
    },
    {
        document: structured_analysis_type_codes_1.NET_WORKING_CAPITAL,
        dependencies: [structured_analysis_type_codes_1.BALANCE_SHEET],
    },
    {
        document: structured_analysis_type_codes_1.REPORTED_INCOME_STATEMENT,
        dependencies: [],
    },
    {
        document: structured_analysis_type_codes_1.DEBT_AND_DEBT_LIKE,
        dependencies: [],
    },
    {
        document: structured_analysis_type_codes_1.BALANCE_SHEET,
        dependencies: [],
    },
];
var getDocumentWithDependencies = function (document) {
    return DocumentsAndDependencies.find(function (x) { return x.document === document; });
};
exports.getDocumentWithDependencies = getDocumentWithDependencies;
